// src/pages/PublicAgentPage.jsx
import { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import knowledgebaseAgentService from "../../services/knowledgebase-agent.service";
import Chatwidget from "../../pages/Chatwidget";
import { showMessage } from "../../customhooks/useNotifier";

const PublicAgentPage = () => {
  const { id } = useParams();
  const [agentData, setAgentData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!id) return;

    knowledgebaseAgentService
      .fetchPublicAgentById(id)
      .then((data) => setAgentData(data))
      .catch((err) =>
        showMessage(err.message || "Failed to load agent widget", "error"),
      )
      .finally(() => setLoading(false));
  }, [id]);

  // NEW: Only detect real browser errors
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    // Fired when iframe successfully loads
    iframe.onload = () => {
      try {
        const iframeUrl = iframe.contentWindow.location.href;

        // Browser network error pages (Chrome/Edge)
        if (
          iframeUrl.startsWith("chrome-error://") ||
          iframeUrl.startsWith("about:neterror") ||
          iframeUrl.startsWith("edge-error://")
        ) {
          setIframeError(true);
          return;
        }

        // SUCCESS → Do NOT mark error
        setIframeError(false);
      } catch (err) {
        // Cross-origin → VALID website loaded → DO NOT treat as error
        setIframeError(false);
      }
    };

    // If iframe fails completely
    iframe.onerror = () => setIframeError(true);
  }, [agentData]);

  if (loading) {
    return (
      <Box sx={{ p: 4, textAlign: "center" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!agentData) {
    return <Typography color="error">Agent widget not found.</Typography>;
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {iframeError ? (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            p: 4,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            background: "#f4f4f4",
          }}
        >
          <Typography variant="h6" color="error">
            This website cannot be displayed in an iframe due to security
            restrictions (X-Frame-Options / CSP).
          </Typography>
        </Box>
      ) : (
        <iframe
          ref={iframeRef}
          src={agentData?.websiteUrl}
          title="Widget Preview"
          style={{
            border: "none",
            width: "100%",
            height: "100%",
            display: "block",
          }}
        />
      )}
      {console.log("PublicAgentPage agentData----->", agentData)}
      {agentData && <Chatwidget agentData={agentData} kbId={agentData.id} />}
    </Box>
  );
};

export default PublicAgentPage;
